// @ts-ignore
/* eslint-disable */
import request from '../../utils/request';

/** 视频详情 # **获取AccessToken** 
<a href='http://auth-service-beta2.shrise.cn/doc.html#/default/token-controller/generateUserAccessTokenUsingPOST' target='_blank'>点击此处获取测试站用户AccessToken</a>参数示例: 
  ```
{
  "productType": 171,
  "userId": 240
}
  ```
 GET /promotion-video/info */
export async function promotionVideoInfoUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.promotionVideoInfoUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultyingxiaoshipinxiangqingxiangying>('/promotion-video/info', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 视频列表 # **获取AccessToken** 
<a href='http://auth-service-beta2.shrise.cn/doc.html#/default/token-controller/generateUserAccessTokenUsingPOST' target='_blank'>点击此处获取测试站用户AccessToken</a>参数示例: 
  ```
{
  "productType": 171,
  "userId": 240
}
  ```
 GET /promotion-video/list */
export async function promotionVideoListUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.promotionVideoListUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.PageResultListyingxiaoshipinliebiaoxiangying>('/promotion-video/list', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}
